export const PULL_ALERTS = 'PULL_ALERTS';
export const SET_ALERTS = 'SET_ALERTS';
export const SET_ALERTS_LOADING = 'SET_ALERTS_LOADING';
export const CREATE_ALERT = 'CREATE_ALERT';
export const PATCH_ALERT = 'PATCH_ALERT';
export const DELETE_ALERT = 'DELETE_ALERT';
export const PULL_SCOPE_ITEMS = 'PULL_SCOPE_ITEMS';
export const SEND_ALERT_TEST_NOTIFICATION = 'SEND_ALERT_TEST_NOTIFICATION';

export const pullAlertsAction = () => ({
  type: PULL_ALERTS
});

export const setAlertsAction = alerts => ({
  type: SET_ALERTS,
  payload: alerts
});

export const setAlertsLoadingAction = isLoading => ({
  type: SET_ALERTS_LOADING,
  payload: isLoading
});

export const createAlertAction = (payload, callback) => ({
  type: CREATE_ALERT,
  payload,
  callback
});

export const patchAlertAction = (payload, callback) => ({
  type: PATCH_ALERT,
  payload,
  callback
});

export const deleteAlertAction = payload => ({
  type: DELETE_ALERT,
  payload
});

export const pullScopeItemsAction = (payload, callback) => ({
  type: PULL_SCOPE_ITEMS,
  payload,
  callback
});

export const sendAlertTestNotificationAction = payload => ({
  type: SEND_ALERT_TEST_NOTIFICATION,
  payload
});
